export const types = [
    { value: 'PC-SFF', displayValue: 'PC-SFF' },
    { value: 'Laptop', displayValue: 'Laptop' },
    { value: 'PC-Desktop', displayValue: 'PC-Desktop' },
    { value: 'PC-Tower', displayValue: 'PC-Tower' },
    { value: 'PC', displayValue: 'PC' },
    { value: 'Server', displayValue: 'Server' },
    { value: 'PC-USDT', displayValue: 'PC-USDT' },
    { value: 'PC-MT', displayValue: 'PC-MT' },
    { value: 'Headphone', displayValue: 'Headphone' },
    { value: 'Watch', displayValue: 'Watch' },
];